import React from "react";
import { Card, CardContent, CardMedia, Grid, Typography } from "@mui/material";
import header from "../assets/divider-white.png";
import infoIcon from "../assets/icons/warning-icon.png";

/** Properties expected by the WarningCard component. 
 * @param {string} content- The string to be displayed by an InfoCard.*/
interface WarningCardProps {
    content: string
    scrollId: string
}

/** A component that displays text as a colored, decorated text box. */
export const WarningCard = (props: WarningCardProps) => {
    const { content, scrollId } = props;

    return (
        <div className="warning-card">
            <Grid container
            direction={"column"}
            alignItems="center">
                <Grid item>
                    <Card sx={{ borderRadius: "inherit", maxWidth: "inherit", maxHeight: "inherit", height: "inherit", backgroundColor: "inherit", color: "inherit"}}>
                        <div className="warning-header">
                            <div className="warning-icon">
                                <CardMedia
                                component="img"
                                image={infoIcon}
                                alt="Warning icon"/>
                            </div>
                            <CardMedia
                            id={scrollId}
                            component="img"
                            image={header}
                            alt="Warning header"/>
                        </div>
                        <CardContent>
                            <Typography>{content}</Typography>
                        </CardContent>
                    </Card>
                </Grid>
            </Grid>
        </div>
    );
}